import React, { useState } from 'react';
import { AccordionItem, Box, Inscription, Preloader } from '@common-fe/common-fe';
import styled from 'styled-components';

import { TierBlock } from './TierBlock/TierBlock';
import { useTiersModule } from './hooks';

interface StyledBoxProps {
  isPageMode?: boolean;
}

export const StyledBox = styled(Box)<StyledBoxProps>`
  transition: all 0.15s;
  span {
    transition: all 0.15s;
  }
  a {
    height: 24px;
  }
`;

export const TiersModule: React.FC = () => {
  const [isExpanded, setExpanded] = useState(false);
  const { planStatus, serviceConfigs, rule, triggerAmounts, isLoadingAll, isEmbeddedOnly } = useTiersModule();

  return (
    <StyledBox pad="l" round="moduleRound" background="module" isPageMode>
      {isLoadingAll ? (
        <Preloader testId="tiers-details" />
      ) : (
        <AccordionItem
          onChange={() => setExpanded(!isExpanded)}
          testId="tiers-module-item"
          iconSize="24px"
          isExpanded={isExpanded}
          text={
            <Inscription
              margin={{ left: 'xxs' }}
              color="textBody"
              weight="bold"
              size="16px"
              lineHeight="22px"
            >
              Tiers
            </Inscription>
          }
          isLeftArrow
        >
          <Box margin={{ top: 'l' }}>
            {rule?.tiers?.map((item, index) => (
              <TierBlock
                key={item?.id}
                tier={item}
                nextTier={rule?.tiers[index + 1]}
                numberOfTier={String(index + 1)}
                isLastItem={index === rule?.tiers?.length - 1}
                healthPlanStatus={planStatus}
                serviceConfigs={serviceConfigs}
                triggerAmounts={triggerAmounts}
                payoutRuleType={item?.payoutRuleType}
                planIdsForCardPurseLock={item?.planIdsForCardPurseLock || []}
                planNamesForCardPurseLock={item?.planNamesForCardPurseLock || []}
                isEmbeddedOnly={isEmbeddedOnly}
              />
            ))}
          </Box>
        </AccordionItem>
      )}
    </StyledBox>
  );
};
